// Copyright (c) Docugami, Inc. All rights reserved.

import { DocHeaderButtonProps, DocumentHeaderButton } from "components/doc_hosting/presentation/DocumentHeaderButton";
import { chunkToolbarColor } from "components/shell/presentation/AppStyles";
import { dgIconNames } from "hooks/dgIcons";
import { useMemo } from "react";

interface PropertiesButtonProps {
    onClick: () => void;
    hidden: boolean;
}

export const PropertiesButton = (props: PropertiesButtonProps): JSX.Element => {
    const propertiesButton: DocHeaderButtonProps = useMemo(() => {
        return {
            label: 'Properties',
            iconProps: {
                source: {
                    name: dgIconNames.DgDocumentProperties,
                    height: 1,
                    width: 1,
                    defaultColor: chunkToolbarColor
                },
                width: 20,
                height: 20
            },
            isSelected: !props.hidden,
            onClick: props.onClick,
            showLabel: true,
            height: '43px'
        }
    }, [props.onClick, props.hidden])

    return <DocumentHeaderButton key={`${propertiesButton.iconProps.source.name}_${propertiesButton.label}`} {...propertiesButton} />;
}
